import { useContext } from 'react';
import axios from '../Axios';
import { Urls } from '../Urls';
import { Activity, currentRequestTimeStamp } from '../Constants';
import { UserApiContext } from '../Components/UserDetailsContext/UserDetailsContext';
import { useMixPanelForTracking } from '../utils/TrackMixPanel';
import { MyCompanyProfileContext } from '../MyCompanyProfileContext';

export const useExpressInterest = () => {
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);

  const submitMegaRFQInterest = ({ moduleName, wantsMegaRFQ }) => {
    Activity([
      {
        screen: 'My Freight Benchmark',
        module: 'Express Interest',
        user_activity: `Express Interest Button Clicked in ${moduleName} (Wants Mega RFQs: ${wantsMegaRFQ ? 'Yes' : 'No'})`,
        timestamp: currentRequestTimeStamp(),
      },
    ]);

    TrackMixPanel({
      ModuleName: 'benchmark_page',
      ScreenName: 'LoRRI-Benchmark',
      Definition: `User has clicked express interest in ${moduleName}`,
      Data: wantsMegaRFQ ? 'Wants Mega RFQs Info: Yes' : 'Wants Mega RFQs Info: No',
    });

    if (!wantsMegaRFQ) return;

    const orgName = userDetails?.company_name || localStorage.getItem('companyname') || '';

    axios.post(`${Urls.benchmarnow}?field=express_interest`, {
      procurement_window: 'Mega RFQ',
      lane_count: '0',
      organisation: orgName,
      notes: 'User expressed interest for Mega RFQ',
    });
  };

  return { submitMegaRFQInterest };
};
